import { Outlet } from "react-router-dom";
import HeadLayout from "@shared/layouts/HeadLayout";
import { useTranslation } from "react-i18next";

const ReturnVoucher = () => {
  const { t } = useTranslation();
  return (
    <>
      <HeadLayout title={t("returnVoucher.returnVoucher")} />
      <Outlet />
    </>
  );
};

export default ReturnVoucher;
